export default __webpack_public_path__ + "static/media/v3-ray-porch.1a02c9fd.jpg";